<template>
  <div>
    <AddLLMbot
      v-if="!uiFlags.isFetchingById && llm_bot"
      :prefilled-data="llm_bot"
    />
    <LoadingState
      v-if="uiFlags.isFetchingById"
      :message="$t('CAMPAIGN.LLM_CHATBOT.EDIT.LOADING_MSG')"
    />
  </div>
</template>

<script>
import AddLLMbot from './AddLLMbot.vue';
import { mapGetters } from 'vuex';
import LoadingState from 'dashboard/components/widgets/LoadingState';
import alertMixin from '../../../../../../shared/mixins/alertMixin';

export default {
  components: {
    AddLLMbot,
    LoadingState,
  },
  mixins: [alertMixin],
  data() {
    return {
      llm_bot: null,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'llmbots/getUIFlags',
      llm_bots: 'llmbots/getLLMBots',
    }),
  },
  watch: {
    '$route.params.llm_bot_id': {
      handler() {
        this.prefillBot();
      },
      immediate: false,
    },
    // 'uiFlags.isFetching': {
    //   handler() {
    //     if (!this.uiFlags.isFetching) {
    //       this.prefillBot();
    //     }
    //   },
    // }
  },
  async mounted() {
    if (!this.llm_bots.length) {
      await this.$store.dispatch('llmbots/fetchLLMBots');
    }
    this.prefillBot();
  },
  methods: {
    async prefillBot() {
      const llm_bot_id = this.$route.params.llm_bot_id;
      if (llm_bot_id) {
        try {
          await this.$store.dispatch('llmbots/fetchLLMBotById', {
            llm_id: llm_bot_id,
          });

          // insted of getiing cache data, call api to get latest data
          this.llm_bot = this.$store.getters['llmbots/getLLMBotById'](
            Number(llm_bot_id)
          );
        } catch (error) {
          console.error('Error fetching LLM Bot by ID:', error);

          this.showAlert(this.$t('AI.AGENT.EDIT.NOT_FOUND_MSG'), 'error');
          this.$router.push({
            name: 'llm_bot_list',
          });

          console.warn('LLM Bot not found with id:', llm_bot_id);
        }
      } else {
        this.llm_bot = null;
      }
    },
  },
};
</script>

<style></style>
